import {
  OutlinedSelect,
  SelectOptionType,
  TextOutlinedInput,
} from '@octano/global-ui';
import { Control } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';

import SectionTitle from '../../../../../../components/text/SectionTitle';
import { useValidations } from '../../../../../../hooks/useValidations';
import { BankAccountType } from '../../types';

const dictPrefix =
  'financialPortal.currentAccount.tabs.currentAccount.applyRefund.transfer';

interface Props {
  control: Control<any>;
}

const ACCOUNT_TYPE_OPTIONS: SelectOptionType[] = [
  { value: BankAccountType.Corriente, label: 'Cuenta Corriente' },
  { value: BankAccountType.Vista, label: 'Cuenta Vista' },
  { value: BankAccountType.Ahorro, label: 'Cuenta de Ahorro' },
];

export default function TransferSubForm({ control }: Props) {
  const { t } = useTranslation();
  const { msgValidations } = useValidations();

  return (
    <>
      <Row className="mb-3">
        <Col xs={12}>
          <SectionTitle text={t(`${dictPrefix}.sectionTitle`)} />
        </Col>
      </Row>
      <Row>
        <Col xs={12} md={3} className="mb-3">
          <TextOutlinedInput
            name="totalAmount"
            control={control}
            type={'number' as any}
            label={t(`${dictPrefix}.totalAmount.label`)}
            placeholder={t(`${dictPrefix}.totalAmount.placeholder`)}
            rules={{
              required: msgValidations.required,
              min: { value: 0.01, message: msgValidations.required },
            }}
          />
        </Col>
        <Col xs={12} md={3} className="mb-3">
          <TextOutlinedInput
            name="bankHolderName"
            control={control}
            label={t(`${dictPrefix}.bankHolderName.label`)}
            placeholder={t(`${dictPrefix}.bankHolderName.placeholder`)}
            rules={{
              required: msgValidations.required,
              maxLength: 255,
            }}
          />
        </Col>
        <Col xs={12} md={3} className="mb-3">
          <TextOutlinedInput
            name="bankName"
            control={control}
            label={t(`${dictPrefix}.bankName.label`)}
            placeholder={t(`${dictPrefix}.bankName.placeholder`)}
            rules={{
              required: msgValidations.required,
              maxLength: 100,
            }}
          />
        </Col>
        <Col xs={12} md={3} className="mb-3">
          <OutlinedSelect
            name="bankAccountType"
            control={control}
            label={t(`${dictPrefix}.bankAccountType.label`)}
            placeholder={t(`${dictPrefix}.bankAccountType.placeholder`)}
            options={ACCOUNT_TYPE_OPTIONS}
            rules={{ required: msgValidations.required }}
          />
        </Col>
        <Col xs={12} md={3} className="mb-3">
          <TextOutlinedInput
            name="bankAccountNumber"
            control={control}
            label={t(`${dictPrefix}.bankAccountNumber.label`)}
            placeholder={t(`${dictPrefix}.bankAccountNumber.placeholder`)}
            rules={{
              required: msgValidations.required,
              maxLength: 50,
            }}
          />
        </Col>
        <Col xs={12} md={3} className="mb-3">
          <TextOutlinedInput
            name="bankContactEmail"
            control={control}
            type={'email' as any}
            label={t(`${dictPrefix}.bankContactEmail.label`)}
            placeholder={t(`${dictPrefix}.bankContactEmail.placeholder`)}
          />
        </Col>
      </Row>
    </>
  );
}
